import styles from './SectionHeader.module.scss';

export interface SectionHeaderProps {
    title: string;
    subtitle?: string;
    rightContent?: string;
}

export default function SectionHeader(props: SectionHeaderProps) {
    const { title, subtitle, rightContent } = props;

    return (
        <div className={styles.sectionHeader}>
            <div>
                <div className={styles.sectionTitle}>{title}</div>
                {subtitle != null && <div className={styles.sectionSubtitle}>{subtitle}</div>}
            </div>
            {rightContent != null && (
                <div className={styles.sectionHeaderRightContent}>{rightContent}</div>
            )}
        </div>
    );
}
